// extracted by mini-css-extract-plugin
export var isWhite = "styles-module--isWhite--9fjyk";
export var mainMenuArea = "styles-module--mainMenuArea--6BmMl";
export var menuPrinicipal = "styles-module--menuPrinicipal--r7mvl";
export var separacion = "styles-module--separacion--ZnJMH";
export var separacionArea = "styles-module--separacionArea--p-fDV";